import React, { useState, useEffect } from 'react';

const FullWidthCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Slide data
  const slides = [
    { src: 's1.jpg', alt: 'First slide' },
    { src: 's2.jpg', alt: 'Second slide' },
    { src: 's3.jpg', alt: 'Third slide' },
    { src: 's4.jpg', alt: 'Fourth slide' },
    { src: 's5.jpg', alt: 'Five slide' },
    { src: 's6.jpg', alt: 'Six slide' },

    { src: 's7.jpg', alt: 'Seven slide' },
  ];

  // Automatically slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 3000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  return (
    
    <div style={styles.carousel}>
      {/* Slides */}
      <div style={styles.overlay}>
  <h1 style={styles.message}>Welcome to Social Audit Portal of Balasore</h1>
  
</div>

      <div style={styles.slidesContainer}>
        {slides.map((slide, index) => (
          <div
            key={index}
            style={{
              ...styles.slide,
              opacity: activeIndex === index ? 1 : 0, // Controls visibility of slides
              zIndex: activeIndex === index ? 1 : 0, // Ensures the active slide is on top
            }}
          >
            <img src={slide.src} alt={slide.alt} style={styles.image} />
          </div>
        ))}
      </div>

      {/* Previous Button */}
      <button style={{ ...styles.control, left: '20px' }} onClick={prevSlide}>
        &#10094;
      </button>

      {/* Next Button */}
      <button style={{ ...styles.control, right: '20px' }} onClick={nextSlide}>
        &#10095;
      </button>

      {/* Indicators */}
      <div style={styles.indicators}>
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            style={{
              ...styles.indicator,
              backgroundColor: activeIndex === index ? '#000' : '#bbb',
            }}
          ></button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  carousel: {
    position: 'relative',
    width: '100%', // Full width
    height: '300px', // Adjust height as needed
    overflow: 'hidden',
    margin: '0 auto', // Center the carousel
  },
  slidesContainer: {
    display: 'relative',
    height: '100%',
    transition: 'opacity 0.5s ease-in-out', // Smooth visibility changes

  },
  slide: {
    position: 'absolute', // Ensures slides are stacked on top of each other
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.5s ease-in-out', // Smooth visibility changes
  },
  
  image: {
    width: '100%', // Full width for the image
    height: '100%', // Full height for the image
    objectFit: 'cover', // Maintain aspect ratio and cover the container
  },
  control: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    fontSize: '24px',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  indicators: {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '10px',
    zIndex: 10,
  },
  indicator: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
  },
  overlay: {
    position: 'absolute',    // To place it over the carousel
    top: '10px',             // Position near the top
    left: '50%',             // Center horizontally
    transform: 'translateX(-50%)', // Adjust for proper centering
    zIndex: 20,              // Make sure it appears above everything else
    color:"rgb(17, 10, 100)",          // Text color
    backgroundColor: 'rgba(255, 255, 255, 0.6)', // Transparent white background

    padding: '10px 20px',    // Padding around the text
    borderRadius: '8px',     // Rounded corners
    textAlign: 'center',     // Center-align text
  },
  
};

export default FullWidthCarousel;
